import styled, { css } from 'styled-components';
import { Button } from '@simplywallst/ui-core';
import { RouterLink } from '@redux-first-router-link';

const link = css`
  ${({ theme }) => theme.typography.base}
  color: ${({ theme }) => theme.color.white};
  display: block;
  position: relative;
  padding: ${({ theme }) => theme.x1spacePx + 3}px
    ${({ theme }) => theme.x2spacePx}px;
`;

export const MenuItemWrapper = styled.li`
  border-bottom: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.1)};
`;

export const MenuItemRouterLink = styled(RouterLink)`
  ${link};
`;

export const MenuItemHREF = styled(Button)`
  text-decoration: none;
  box-shadow: none;
  ${link};
  &:hover {
    box-shadow: none;
  }
`;
